/**
 * Extracts useful fields from Office.js / OfficeExtension errors (often only `GeneralException`).
 */

export function formatOfficeJsError(err: unknown): Record<string, unknown> {
  const base: Record<string, unknown> = {
    message: err instanceof Error ? err.message : String(err),
    name: err instanceof Error ? err.name : typeof err,
  };
  if (err === null || err === undefined) {
    return base;
  }
  const e = err as Record<string, unknown> & {
    code?: string;
    traceMessages?: unknown;
    debugInfo?: unknown;
    innerError?: unknown;
  };
  if (e.code != null) base.code = e.code;
  if (e.traceMessages != null) base.traceMessages = e.traceMessages;
  if (e.innerError != null) {
    try {
      base.innerError =
        typeof e.innerError === 'object'
          ? JSON.parse(JSON.stringify(e.innerError, Object.getOwnPropertyNames(e.innerError as object)))
          : e.innerError;
    } catch {
      base.innerError = String(e.innerError);
    }
  }
  if (e.debugInfo != null) {
    try {
      const d = e.debugInfo as Record<string, unknown>;
      base.debugInfo = JSON.parse(JSON.stringify(d, Object.getOwnPropertyNames(d)));
    } catch {
      base.debugInfo = String(e.debugInfo);
    }
  }
  return base;
}
